import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { generalService } from '../../../../services/general.service';
import { DataService } from '../../../../utils/data.service';
import { DataSourceGrid } from '../../../../utils/data-source-grid.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';

@Component({
    selector: 'my-balnzaComprobacion-generarXML',
    templateUrl: 'balanzaComprobacion-generarXML.html',
    providers: [generalService]
})
export class BalanzaComprobacionXMLComponent implements OnInit{
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    myForm: FormGroup;
    dataSource: DataSourceGrid | MatTableDataSource<any> | null = null;
    fechaInicioOptions: { id: number, name: string }[] = [];
    fechaFinOptions: { id: number, name: string }[] = [];
    
    public rfcCompany = '';
    public list_XML: any[] = [];
    public anioXML = 0;
    public mesXML = "";
    public fechaInicioFormateada: any;
    public fechaFinFormateada: any;
    anioActual: number = new Date().getFullYear();
    mesActual: number = new Date().getMonth() + 1;
    list_TipoEnvio =[
      {ID: 'N', value: 'Normal'},
      {ID: 'C', value: 'Complementario'}
    ];
    
    aniosRestantes: number = 30; 
    anos: number[] = Array.from({ length: this.aniosRestantes + 1 }, (_, index) => this.anioActual - index);
    meses: { nombre: string, valor: number }[] = [
        { nombre: 'Enero', valor: 1 },
        { nombre: 'Febrero', valor: 2 },
        { nombre: 'Marzo', valor: 3 },
        { nombre: 'Abril', valor: 4 },
        { nombre: 'Mayo', valor: 5 },
        { nombre: 'Junio', valor: 6 },
        { nombre: 'Julio', valor: 7 },
        { nombre: 'Agosto', valor: 8 },
        { nombre: 'Septiembre', valor: 9 },
        { nombre: 'Octubre', valor: 10 },
        { nombre: 'Noviembre', valor: 11 },
        { nombre: 'Diciembre', valor: 12 }
    ];
  
    constructor(private formBuilder: FormBuilder,
                private _generalService: generalService,
                public dataService: DataService,
                public dialog: MatDialog) {
                this.myForm = new FormGroup({});
    }
   
  
    ngOnInit() {
       this.buildForm();
    }
   
    cerrarModal(){
        this.dataService.dialogRef.close();
    }
    buildForm() {
      this.myForm = this.formBuilder.group({
        tipoEnvioForm:['', Validators.required],
        anioForm: [this.anioActual],
        mesForm: [this.mesActual]
      });
    }
    
    generarArchivoXML() {
      this.getDataXML();
    }
    getFormattedDate(): string {
      const anio = this.myForm.controls['anioForm'].value;
      const mes = this.myForm.controls['mesForm'].value;
      return `${anio}-${mes < 10 ? '0' + mes : mes}-01`;
    }
    
    getDataXML(){

      const params = { 
        loacs: sessionStorage.getItem('acslo'),
        fechaXML: this.getFormattedDate()
      };
      
      this._generalService.metodoCallParams(params, 'BalanzaComprobacion/gedDataXML',true).subscribe(
        (result) => {
          const tableResult = JSON.parse(result);
          this.list_XML = tableResult.Table;
          this.rfcCompany = tableResult.Table1[0]['RFC'];
          this.cerrarModal();

          //const mes = this.meses.find((element) => element.valor === this.myForm.controls['mesForm'].value);
          this.mesXML = this.myForm.controls['mesForm'].value;
          
          this.anioXML = this.myForm.controls['anioForm'].value;
          this.downloadXml(this.list_XML, 'Balanza'+this.anioXML+this.mesXML.toString().padStart(2, '0'));
             
        }, (error) => {
          console.log(error as any);
      });
    }
    
    downloadXml(array: any[], fileName: string): void {
      const xmlString: string = this.arrayToXml(array);
      const blob = new Blob([xmlString], { type: 'application/xml' });
      const url = window.URL.createObjectURL(blob);
        
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
  
      // Liberar recursos
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }
    
    arrayToXml(array) {
      
      let RFC = this.rfcCompany;
      let tipoEnvio = ''
      let Mes = this.mesXML.toString().padStart(2, '0');
      tipoEnvio = this.myForm.controls['tipoEnvioForm'].value;
      let xmlString = `<BCE:Balanza xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:BCE="http://www.sat.gob.mx/esquemas/ContabilidadE/1_3/BalanzaComprobacion" 
      xsi:schemaLocation="http://www.sat.gob.mx/esquemas/ContabilidadE/1_3/BalanzaComprobacion http://www.sat.gob.mx/esquemas/ContabilidadE/1_3/BalanzaComprobacion/BalanzaComprobacion_1_3.xsd" Version="1.3" RFC="${RFC}" Mes="${Mes}" Anio="${this.anioXML}" TipoEnvio="${tipoEnvio}">\n`; 
      array.forEach(item => {
        xmlString += `<BCE:Ctas `;
        Object.keys(item).forEach(key => {
          xmlString += `${key}="${item[key]}" `;
        });
        xmlString += `/>\n`;
      });   
      xmlString += '</BCE:Balanza>';    
      return xmlString;
    }
}



// WEBPACK FOOTER //
// ./src/app/Contabilidad/balanzaComprobacion/consultar/archivoXML/balanzaComprobacion-generarXML.ts